import { Input, Directive } from '@angular/core';

import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { ColumnComponent, BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { LocalizationService } from '@progress/kendo-angular-l10n';
import { localizeOperators } from '../utils';

const stringOperators = localizeOperators({
	"filterEqOperator": "eq",
	"filterNotEqOperator": "neq",
	// eslint-disable-next-line
	"filterContainsOperator": "contains",
	"filterNotContainsOperator": "doesnotcontain",
	"filterStartsWithOperator": "startswith",
	"filterEndsWithOperator": "endswith",
	"filterIsNullOperator": "isnull",
	"filterIsNotNullOperator": "isnotnull",
	"filterIsEmptyOperator": "isempty",
	"filterIsNotEmptyOperator": "isnotempty"
});

@Directive()
export abstract class DropdownFilterComponent extends BaseFilterCellComponent {

	@Input() public column: ColumnComponent;
	@Input() public filter: CompositeFilterDescriptor;
	@Input() public operator: string;


    /**
     * The current filter for the associated column field.
     * @readonly
     * @type {FilterDescriptor}
     */
	get currentFilter(): FilterDescriptor {
		return this.filterByField((this.column || (<any>{})).field);
	}

    /**
     * The current filter operator for the associated column field.
     * @readonly
     * @type {string}
     */
	get currentOperator(): string {
		return this.currentFilter ? (<string>this.currentFilter.operator) : this.operator;
	}

    /**
     * Called when the dropdown value changes. Pushes the new value into
     * the grid's filter service (or removes the filter when cleared).
     */
	public onChange(value: any): void {
		this.applyFilter(
			value === null || value === undefined
				? this.removeFilter(this.column.field)
				: this.updateFilter({
					field: this.column.field,
					operator: this.operator || 'eq',
					value: value
				})
		);
	}

	protected defaultOperators: Array<{
		text: string;
		value: string;
	}>;

	constructor(filterService: FilterService, protected localization: LocalizationService) {
		super(filterService);
		this.operator = "contains";
		this.defaultOperators = stringOperators(this.localization);
	}
}